/**
 * Test IDs for QA automation.
 */
export const testIds = {
  reorderableShipmentsRemove: "reorderable-shipments-remove",
} as const;
